// extracted by mini-css-extract-plugin
export default {"item":"Card_item__0arK9","content":"Card_content__nR9na","backgroundShadow":"Card_backgroundShadow__5cPZm","item_landing":"Card_item_landing__J4TzG"};